"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_node_gallery_card_component_1 = __importDefault(require("../scenario-node-gallery-card/scenario-node-gallery-card.component"));

var node_data_view_styles_1 = require("./node-data-view.styles");

var UrlActionView = function UrlActionView(_ref) {
  var url = _ref.url;
  return react_1.default.createElement(node_data_view_styles_1.StyledUrlViewDiv, null, url);
};

var EmptyActionView = function EmptyActionView() {
  return react_1.default.createElement(node_data_view_styles_1.StyledEmptyActionDiv, null, react_1.default.createElement(node_data_view_styles_1.StyledEmptyActionTextP, null, "\u30A2\u30AF\u30B7\u30E7\u30F3\u304C\u5B58\u5728\u3057\u307E\u305B\u3093"));
};

var NodeDataView = function NodeDataView(_ref2) {
  var nodeData = _ref2.nodeData,
      handleEditClick = _ref2.handleEditClick;
  if (!nodeData) return null;
  var nodeId = nodeData.nodeId,
      node = nodeData.node,
      url = nodeData.url;
  return react_1.default.createElement("div", null, node ? react_1.default.createElement(scenario_node_gallery_card_component_1.default, {
    node: node,
    enableDetailView: true,
    onEditClick: function onEditClick() {
      return handleEditClick(nodeId);
    }
  }) : url ? react_1.default.createElement(UrlActionView, {
    url: url
  }) : react_1.default.createElement(EmptyActionView, null));
};

exports.default = NodeDataView;